import { render } from "./list-materials.vue?vue&type=template&id=63cdd91d&ts=true"
import script from "./list-materials.vue?vue&type=script&lang=ts"
export * from "./list-materials.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__